var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#BD0034;}\n\t.st2{fill:#1A237B;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 298.7,
    width: 512,
    y: 106.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "342.8,214.7 512,119.9 512,106.7 500.3,106.7 307.4,214.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "334.8,303.4 512,402.5 512,382.7 370.2,303.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,129.4 151.5,214.7 187,214.7 0,109.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "178.9,303.4 0,403.6 0,405.4 32.3,405.4 214.4,303.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "477,106.7 297.7,106.7 297.7,207.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "218.5,106.7 40,106.7 218.5,207.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "512,214.7 512,146.1 390.4,214.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "512,371.1 512,303.4 390.4,303.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "50.1,405.4 218.5,405.4 218.5,310.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "297.7,405.4 466.6,405.4 297.7,310.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0,303.4 0,374.2 125.8,303.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0,214.7 125.8,214.7 0,143.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "234.4,106.7 234.4,232.4 0,232.4 0,285.6 234.4,285.6 234.4,405.4 281.9,405.4 281.9,285.6 512,285.6    512,232.4 281.9,232.4 281.9,106.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.5b4dc721f3fb33a0cc33fbecc29a4dec.svg";
export { ForwardRef as ReactComponent };